import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../core/i18n'
import * as constants from '../../../static/constants'
import { Panel, Pagination } from '../../atoms'
import { IUser } from '../../../static/interfaces'
import SidebarLayout from '../_layouts/sidebarLayout'

interface IProps {
  user: IUser
  pagination: any
  filter: React.ReactNode
  children: React.ReactNode
}

const MessageIndexLayout: React.FC<IProps> = ({ user, pagination, children, filter }) => {
  const onChangePageHandler = page => {
    const params = new URLSearchParams(window.location.search)
    params.set('page', page)

    location.href = `${location.pathname}?${params.toString()}`
  }
  return (
    <SidebarLayout user={user} className="messageIndexLayout">
      <Panel noDecoration={user.guest ? true : false} title={I18n.t('conversation.messages')}>
        <ShowWrapper>
          {(user.agent || user.guide) && filter}
          <div className="Show_Inner">
            {children}
            {pagination && (
              <Pagination
                onChangePageHandler={onChangePageHandler}
                currentPage={pagination.current_page}
                prevPage={pagination.prev_page}
                nextPage={pagination.next_page}
                totalCount={pagination.total_count}
                totalPages={pagination.total_pages}
              />
            )}
          </div>
        </ShowWrapper>
      </Panel>
    </SidebarLayout>
  )
}

const ShowWrapper = styled.div`
  overflow: auto;
  .Show_Inner {
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: 0 0 24px;
    background-color: ${constants.COLORS.white};
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    padding: 0 16px;
  }
`

export default MessageIndexLayout
